module.exports = __webpack_public_path__ + "static/img/file-video.f5c8d984.svg";